import { inject, Injectable } from '@angular/core';
import { forkJoin, map, Observable } from 'rxjs';
import { AgendaService } from './agenda.service';
import { BusinessService } from './business.service';
import { Agenda, Professional } from '../../shared/interfaces';

export interface AgendaWithProfessional extends Agenda {
  professionalName: string;
  professionalFirstName: string;
  professionalLastName: string;
}

@Injectable({ providedIn: 'root' })
export class AgendasWithProfessionalsService {
  private readonly agendaService = inject(AgendaService);
  private readonly businessService = inject(BusinessService);

  /**
   * Get agendas with professional information for a business
   */
  getAgendasWithProfessionals(
    businessId: string
  ): Observable<AgendaWithProfessional[]> {
    return forkJoin({
      agendas: this.agendaService.getAgendas(businessId),
      professionals: this.businessService.searchEntityByBusinessId(
        businessId,
        'professionals',
        '',
        1,
        100
      ) as Observable<Professional[]>,
    }).pipe(
      map(({ agendas, professionals }) => {
        // Create a map of professionalId -> professional
        const professionalMap = new Map<string, Professional>();
        professionals.forEach((prof) => {
          if (prof.userId) {
            professionalMap.set(prof.userId, prof);
          }
        });

        // Combine agendas with professional information
        return agendas.map((agenda) => {
          const professional =
            agenda.professionalId
              ? professionalMap.get(agenda.professionalId)
              : null;
          const professionalName = professional
            ? `${professional.firstName || ''} ${professional.lastName || ''}`.trim() ||
              professional.email ||
              'Profesional'
            : 'Sin profesional';

          return {
            ...agenda,
            professionalName,
            professionalFirstName: professional?.firstName || '',
            professionalLastName: professional?.lastName || '',
          } as AgendaWithProfessional;
        });
      })
    );
  }
}

